export const AppResolution = {
  Hd: '720',
  FullHd: '1080',
} as const;

export type AppResolutionType = (typeof AppResolution)[keyof typeof AppResolution];
